import * as yup from 'yup';

import {
  ExportDataEntityEnum,
  ExportDataFileFormatEnum,
  ExportDataTypeEnum,
} from '../../../../shared/models';

export const exportDataParameterSortSchema = yup
  .object({
    direction: yup.string().oneOf(['ASC', 'DESC']).required(),
    key: yup.string().required(),
  })
  .noUnknown();

export const exportDataParameterSchema = yup
  .object({
    filters: yup
      .object({
        combinator: yup.string().oneOf(['and', 'or']).required(),
        rules: yup.array().of(yup.mixed()).required(),
      })
      .nullable()
      .default(() => ({
        combinator: 'and',
        rules: [],
      })),
    sorts: yup
      .array()
      .of(exportDataParameterSortSchema)
      .default(() => []),
    columns: yup
      .array()
      .of(yup.string())
      .default(() => []),
  })
  .noUnknown();

export const exportDataFileConfigSchema = yup
  .object({
    format: yup
      .mixed<ExportDataFileFormatEnum>()
      .oneOf(Object.values(ExportDataFileFormatEnum))
      .required(),
  })
  .noUnknown();

export const createExportDataSchema = yup
  .object({
    workspaceId: yup.string().required().uuid(),
    type: yup
      .mixed<ExportDataTypeEnum>()
      .oneOf(Object.values(ExportDataTypeEnum))
      .required(),
    entity: yup
      .mixed<ExportDataEntityEnum>()
      .oneOf(Object.values(ExportDataEntityEnum))
      .required(),
    config: exportDataFileConfigSchema.required(),
    parameters: exportDataParameterSchema.required(),
  })
  .noUnknown();
